import React from "react";
import green from "../images/green.svg";
import pink from "../images/pink.svg";
import white from "../images/white.svg";
import yellow from "../images/yellow.svg";
import orange from "../images/orange.svg";
import { Link } from "react-router-dom";

const Section = ({ isReverse = false, img, heading, description, color }) => {
  return (
    <div
      className={`base-wrapper flex ${
        isReverse
          ? "md:flex-row flex-col-reverse"
          : "md:flex-row-reverse flex-col-reverse"
      } my-[100px] md:my-[150px] gap-[50px] relative`}
    >
      <img
        src={
          color === "green"
            ? green
            : color === "white"
            ? white
            : color === "pink"
            ? pink
            : color === "orange"
            ? orange
            : yellow
        }
        className={`absolute ${
          isReverse
            ? "md:-left-[500px] md:-top-[140px]"
            : "md:-right-[500px] md:-top-[140px]"
        } scale-[2] md:scale-[1.7] -z-10`}
        alt=""
      />
      <div className="flex flex-col gap-[10px] md:gap-[20px] md:w-[60%]">
        <div className="text-[25px] md:text-[48px]">{heading}</div>
        <div className="text-[#a8a8a8] text-[15.5px] leading-[1.5] tracking-[.85px]">
          {description}
        </div>
        <Link to="/join">
          <div className="btn mt-[100px]">Join now</div>
        </Link>
      </div>
      <div className="md:w-[40%] relative">
        <img
          src={img}
          alt=""
          className="w-full md:w-[390px] md:h-[390px] object-contain object-left-bottom bg-[#202020] rounded-[30px] "
        />
        <div className="w-[95px] h-[30px] rounded-full border-[1px] border-[#FF9142] absolute -right-[10px] -top-[20px] md:scale-100 scale-75"></div>
        <div className="w-[50px] h-[152px] rounded-full border-[1px] border-[#FF9142] absolute -left-[30px] bottom-[0px] md:scale-100 scale-75"></div>
      </div>
    </div>
  );
};

export default Section;
